import { useQuery } from 'react-query'
import { useDealership } from '../../../../store/zustand/dealershipStore'
import request from '../../../request'
import { useBuildQueryParams } from '../../../../lib/hooks/useBuildQueryParams'
import { isEmpty } from 'lodash'

export const useGetSalePathsOverallMetrics = ({
  filters,
}: {
  filters?: Record<string, unknown>
}) => {
  const dealership = useDealership()
  const queryParams = useBuildQueryParams(filters)
  return useQuery(
    [
      'dealership',
      dealership?.id,
      'performance',
      'sale-paths',
      'metrics',
      'overall',
      queryParams,
    ],
    () =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/performance/sale-paths/metrics/overall`,
        method: 'GET',
        params: {
          ...queryParams,
        },
      }).then((res: any) => res.data),
    {
      enabled: !!dealership,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    },
  )
}
